import { PromotionParam } from 'src/models/Promotion'
import { toQueryParam } from './promotion'

export const GET_MASTER_DATA = '/api/v2/master_data'

export const POST_SIGN_IN = '/companies/sign_in.json'
export const POST_SIGN_IN_WITH_COGNITO = '/companies/sign_in_with_cognito'
export const GET_SIGN_OUT = '/sign_out.json'

export const POST_SHOW_FACEBOOK_RELATION = '/show_facebook_relation'
export const PUT_FACEBOOK_DISLINKING = '/delete_fb_relation'

export const GET_CURRENT_COMPANY = '/current_company/me.json'
export const PUT_PROFILE = '/companies/profile.json'
export const PUT_COMPANY = '/companies/company'
export const PUT_SCHEDULE_URL = '/companies/schedule_url'
export const PUT_SCHEDULE_URL_BANNER_LAST_CLOSED_AT =
  '/companies/schedule_url_banner_last_closed_at'
export const PUT_IS_AGREED_POLICY = '/companies/is_agreed_policy'
export const PUT_SETTLER = '/companies/settler.json'
export const POST_COMPANY_BUY_NEEDS = '/company_buy_needs.json'
export const POST_COMPANY_SOLUTIONS = '/api/v1/company_solution'

export const CONTRIBUTION_SEARCH_CONDITIONS =
  '/api/v1/contribution_search_conditions.json'
export const contributionSearchConditionsId = (id: number) =>
  `/api/v1/contribution_search_conditions/${id}.json`
export const GET_CONTRIBUTIONS = '/api/v2/contributions.json'
export const GET_PREMIUM_CONTRIBUTIONS = '/api/v1/premium_contributions'
export const GET_PREMIUM_CONTRIBUTIONS_SEARCH =
  '/api/v1/premium_contributions/search.json'
export const getPremiumContribution = (id: number) =>
  `/api/v1/premium_contributions/${id}.json`
export const GET_MY_CONTRIBUTIONS = '/companies/company_contributions.json'
export const NEW_CONTRIBUTION = '/companies/company_contributions/new.json'
export const POST_CONTRIBUTION = '/companies/company_contributions'
export const getContribution = (id: number) => `/contributions/${id}.json`
export const putContribution = (id: number) =>
  `/companies/company_contributions/${id}`
export const getMessagesFromContribution = (id: number) =>
  `/companies/company_contributions/${id}/comment_companies`
export const postMessageToContribution = (id: number) =>
  `/contributions/${id}/create_comment_company.json`
export const putContributionShareFb = (id: number) =>
  `/companies/company_contributions/${id}/complete_share_fb`

export const GET_MY_PAGE_DATA = '/companies/my_page_data.json'
export const GET_COMPANY_NOTIFICATIONS = '/api/v1/company_notifications.json'

export const GET_RECOMMENDATIONS = '/companies/recommend.json'
export const GET_REQUEST_BOXES = '/companies/request_boxes.json'
export const GET_SENT_REQUEST_BOXES = '/companies/request_boxes/sent_list.json'
export const POST_INTERESTED = '/companies/request_boxes.json'
export const POST_NOT_INTERESTED = '/companies/request_boxes/not_interest.json'
export const POST_REJECT_REQUEST = '/companies/request_boxes/reject.json'

export const getProfile = (id: number, promotionParam?: PromotionParam) =>
  `/comanies/${id}/show_profile${
    promotionParam ? `?${toQueryParam(promotionParam)}` : ''
  }`

export const GET_ROOMS = '/companies/messages.json'

const SCHEDULED_SENDING_MESSAGES = '/scheduled_sending_messages'
export const GET_SCHEDULED_SENDING_MESSAGES = SCHEDULED_SENDING_MESSAGES
export const POST_SCHEDULED_SENDING_MESSAGE = SCHEDULED_SENDING_MESSAGES
export const deleteScheduledMessage = (id: number) =>
  `${SCHEDULED_SENDING_MESSAGES}/${id}`
export const patchScheduledMessage = (id: number) =>
  `${SCHEDULED_SENDING_MESSAGES}/${id}`

export const putReverseRead = (id: number) =>
  `/api/v1/room_messages/${id}/reverse_read`

const FIXED_MESSAGES = '/api/v1/fixed_messages'
export const GET_FIXED_MESSAGES = `${FIXED_MESSAGES}.json`
export const POST_FIXED_MESSAGES = `${FIXED_MESSAGES}.json`
export const putFixedMessages = (id: number) => `${FIXED_MESSAGES}/${id}.json`
export const postMessageReport = (messageId: number) =>
  `/companies/messages/${messageId}/report`
export const postRoomHidden = (url: string) => `${url}.json`

// Referrer only
export const GET_DELETED_GROUPS = `/companies/trashed_messages.json`
const SwitchRoomStatus = (roomId: number) =>
  `/companies/messages/${roomId}/switch_status`
export const postGroupDelete = SwitchRoomStatus
export const postGroupRestore = SwitchRoomStatus

export const GET_ROOMS_BEFORE_FEEDBACK =
  '/api/v1/rooms_before_feedback/index_for_web'
export const GET_ROOMS_BEFORE_FEEDBACK_RECEIVED_LIST =
  '/api/v1/rooms_before_feedback/received_list'
export const GET_ROOMS_BEFORE_APPOINTMENT = '/api/v1/rooms_before_appointment'
export const POST_FEEDBACK = '/api/v1/feedbacks/create_by_web'
export const POST_PENDING_FEEDBACK = '/api/v1/pending_feedbacks'
export const POST_APPOINTMENT = '/api/v1/appointments.json'
export const getNegativeBadges = (receiverCompanyId: number) =>
  `/api/v1/negative_badges?receiver_company_id=${receiverCompanyId}`
export const POST_NEGATIVE_BADGES = '/api/v1/negative_badges'

export const POST_EVENT = '/api/v2/events.json'
export const getEvents = (pageIndex?: number, per?: number) =>
  `/api/v2/events?page=${pageIndex}&per=${per}`
export const getEvent = (id: number) => `/api/v2/events/${id}`

export const GET_ALERTS = '/api/v1/alerts'
export const PUT_ALERTS = (id: number) => `/api/v1/alerts/${id}`

export const getUsageHistories = (pageIndex: number, per: number) =>
  `/api/v1/usage_histories?page=${pageIndex}&per=${per}`

export const POST_COMPANY_MEMOS = '/companies/memos.json'
export const DELETE_COMPANY_MEMOS = '/companies/memos/delete_memo.json'
export const POST_COMPANY_GROUP_MEMOS = '/companies/group/memos.json'
export const DELETE_COMPANY_GROUP_MEMOS =
  '/companies/group/memos/delete_memo.json'
export const COMPANY_MESSAGE_ROOM_PINS = `/api/v1/company_message_room_pins`
export const COMPANY_MESSAGE_CUSTOM_STATUS = `/api/v1/company_message_custom_status`
export const APPLY_COMPANY_MESSAGE_CUSTOM_STATUS = `/api/v1/company_message_custom_status/apply`

export const GET_PERSONAS = '/api/v1/personas'
export const POST_PERSONAS = '/api/v1/personas'
export const GET_PERSONA_SEARCH_COMPANY_COUNT =
  '/api/v1/personas/search_company_count'
export const getPersona = (id: number) => `/api/v1/personas/${id}`
export const putPersona = (id: number) => `/api/v1/personas/${id}`

export const PUT_COMPANY_SPECIALTIES = '/api/v1/company_specialty'

export const POST_PURCHASES = '/api/v2/purchases'

export const POST_MESSAGE_AVAILABLE = '/update_message_available'
export const POST_EMAIL_SETTINGS = '/update_receive_message_setting'
export const POST_UPDATE_SHOW_MESSAGE_COUNT_SIDE_MESSAGE =
  '/update_show_message_count_side_message'
export const POST_SMS_NOTICE_FLAG = '/sms_notice_flag'
export const POST_EMAIL_NOTICE_FLAG = '/email_notice_flag'
export const POST_CHATWORK_NOTICE = '/companies/needs/chatwork_update.json'
export const POST_SLACK_NOTICE = '/companies/needs/slack_update.json'

export const GET_KEEPS = '/companies/keep.json'
export const POST_KEEPS = '/api/v1/company_keeps'
export const postKeeps = (id: number) => `/api/v1/company_keeps/${id}`

export const GET_NEEDS = '/companies/needs.json'
export const GET_NEEDS_CSV = '/companies/needs.csv'

export const COMPANY_SEARCH_CONDITIONS =
  '/api/v1/company_search_conditions.json'
export const companySearchConditionsId = (id: number) =>
  `/api/v1/company_search_conditions/${id}.json`

export const GET_COMPANY_MESSAGE_ROOM_TAGS = '/api/v1/company_message_room_tags'
export const POST_COMPANY_MESSAGE_ROOM_TAGS =
  '/api/v1/company_message_room_tags'
export const putCompanyMessageRoomTag = (id: number) =>
  `/api/v1/company_message_room_tags/${id}`
export const deleteCompanyMessageRoomTag = (id: number) =>
  `/api/v1/company_message_room_tags/${id}`
export const POST_COMPANY_MESSAGE_ROOM_TAG_MAPPINGS =
  '/api/v1/company_message_room_tag_mappings'
export const deleteCompanyMessageRoomTagMapping = (id: number) =>
  `/api/v1/company_message_room_tag_mappings/${id}`

export const putFirstSetting = '/api/v1/apply/first_setting'

export const POST_CREATE_COMPANY = '/apply/create_from_registration.json'

export const MESSAGE_GUEST = (uuid: string) => `/api/v1/message_guests/${uuid}`
export const MESSAGE_GUEST_SEND = (uuid: string) =>
  `/api/v1/message_guests/${uuid}/send_message`

export const POST_PAID_MODAL_OPEN_LOG = '/api/v1/paid_modal_open_logs'
export const putPaidModalOpenLog = (id: number) =>
  `${POST_PAID_MODAL_OPEN_LOG}/${id}`

export const GET_TIMELINE = '/api/v1/timelines'

export const getFeedbacks = (pageIndex: number) =>
  `/api/v1/feedbacks?page=${pageIndex}`

export const getSentFeedbacks = (pageIndex: number) =>
  `/api/v1/feedbacks/sent_list?page=${pageIndex}`

export const GET_ADVERTISEMENT = '/api/v1/advertisements'

export const POST_MY_PAGE_ACTION_LOG = '/api/v1/my_page_action_logs'

export const PUT_INTRODUCTORY_TEXT = '/api/v1/introductory_texts'

export const GET_CONTENTS = `/api/v1/contents`
export const getSearchContents = (
  tagIds?: number[],
  orderBy?: string,
  filterBy?: string,
  keyword?: string,
  category?: string,
  pageIndex: number = 1,
  perPage: number = 15,
) => {
  const params = new URLSearchParams()
  if (tagIds && tagIds.length > 0)
    tagIds.forEach((tagId) => params.append('tag_ids[]', tagId.toString()))
  if (orderBy) params.append('order_by', orderBy)
  if (filterBy) params.append('filter_by', filterBy)
  if (keyword) params.append('keyword', keyword)
  if (category) params.append('category', category)
  params.append('page', pageIndex.toString())
  params.append('per_page', perPage.toString())
  return `/api/v1/contents/search?${params.toString()}`
}
export const getContent = (id: number, previewToken?: string) => {
  const params = new URLSearchParams()
  if (previewToken) params.append('preview_token', previewToken)
  const query = params.toString()
  return `/api/v1/contents/${id}${query ? `?${query}` : ''}`
}
export const getContentTags = (category?: string) => {
  const params = new URLSearchParams()
  if (category) params.append('category', category)
  return `/api/v1/contents/tags?${params.toString()}`
}

export const GET_EXHIBITIONS = `/api/v1/exhibitions`
export const getSearchExhibitions = (
  tagIds?: number[],
  genre?: string,
  pageIndex: number = 1,
  orderBy?: string,
  filterBy?: string,
  keyword?: string,
) => {
  const params = new URLSearchParams()
  if (tagIds && tagIds.length > 0)
    tagIds.forEach((tagId) => params.append('tag_ids[]', tagId.toString()))
  if (genre) params.append('genre', genre)
  if (orderBy) params.append('order_by', orderBy)
  if (filterBy) params.append('filter_by', filterBy)
  if (keyword) params.append('keyword', keyword)
  params.append('page', pageIndex.toString())
  return `/api/v1/exhibitions/search?${params.toString()}`
}
export const getExhibition = (id: number) => `/api/v1/exhibitions/${id}`
export const getExhibitionPdf = (
  id: number,
  options?: { disposition?: 'inline' | 'attachment' },
) => {
  const params = new URLSearchParams()
  if (options?.disposition) params.append('disposition', options.disposition)
  const query = params.toString()
  return `/api/v1/exhibitions/${id}/download_pdf${query ? `?${query}` : ''}`
}
export const POST_LIKE_HISTORIES = `/api/v1/exhibition_like_histories`
export const POST_CONTENT_LIKE_HISTORIES = '/api/v1/content_like_histories'
export const DELETE_CONTENT_LIKE_HISTORY = (contentId: number) =>
  `/api/v1/content_like_histories/${contentId}`

export const POST_CONTENT_BOOKMARKS = '/api/v1/content_bookmarks'
export const DELETE_CONTENT_BOOKMARK = (contentId: number) =>
  `/api/v1/content_bookmarks/${contentId}`

export const POST_EXHIBITION_BOOKMARKS = '/api/v1/exhibition_bookmarks'
export const DELETE_EXHIBITION_BOOKMARK = (exhibitionId: number) =>
  `/api/v1/exhibition_bookmarks/${exhibitionId}`
